import { APPOINTMENT_TASK_REMINDER_OPTIONS } from '@repo/crm-atoms';
import { ceilDate } from '@repo/utils';
import dayjs from 'dayjs';

export const TASK_STATUSES = {
  pending: 'pending',
  completed: 'completed',
  overdue: 'overdue',
  cancelled: 'cancelled',
  archived: 'archived',
} as const;

export type TaskBaseStatusEnum = typeof TASK_STATUSES[keyof typeof TASK_STATUSES];

export const TASK_CONFIG: {
  [key in TaskBaseStatusEnum]: {
    dividerClassName?: string;
    // the order is used to sort the tasks
    order: number;
  }
} = {
  [TASK_STATUSES.pending]: {
    order: 1,
    dividerClassName: 'yellowDivider',
  },
  [TASK_STATUSES.overdue]: {
    order: 0,
    dividerClassName: 'redDivider',
  },
  [TASK_STATUSES.completed]: {
    order: 2,
    dividerClassName: 'greenDivider',
  },
  [TASK_STATUSES.cancelled]: {
    order: 3,
  },
  [TASK_STATUSES.archived]: {
    order: 4,
  },
} as const;

export const LIST_TASK_LIMIT = 30;

export const TASK_TEMPLATE_TYPES = {
  appointment: 'appointment',
  todo: 'todo',
} as const;

export type TaskTemplateTypeEnum = typeof TASK_TEMPLATE_TYPES[keyof typeof TASK_TEMPLATE_TYPES];

export const VISIBLE_STATUSES_IN_LEAD_DETAILS: TaskBaseStatusEnum[] = [
  TASK_STATUSES.pending,
  TASK_STATUSES.overdue,
  TASK_STATUSES.completed,
];

export const TODO_TASK_REMINDER_OPTIONS = [
  { label: '0 days before', value: 0 },
  { label: '1 day before', value: 1 },
  { label: '2 days before', value: 2 },
  { label: '3 days before', value: 3 },
  { label: '4 days before', value: 4 },
];

export const DEFAULT_TIME_VALUE = dayjs().hour(9).minute(0);

export const PRESET_TASK_CONFIG = {
  reminder_config: {
    seconds: APPOINTMENT_TASK_REMINDER_OPTIONS?.[0]?.value,
    before_days: TODO_TASK_REMINDER_OPTIONS?.[1]?.value,
    at_time: DEFAULT_TIME_VALUE,
  },
  config: {
    calendar_invite_for_owner: false,
    calendar_invite_for_lead: false,
    calendar_invite_for_organizer: false,
  },
} as const;

export const APPOINTMENT_PRESET_CONFIG = {
  ...PRESET_TASK_CONFIG,
  start_time: ceilDate(dayjs(), 'minutes', 15),
  end_time: ceilDate(dayjs(), 'minutes', 15).add(30, 'minute'),
} as const;

export const setTemplateByType = (type: TaskTemplateTypeEnum) => {
  switch (type) {
    case TASK_TEMPLATE_TYPES.appointment:
      return APPOINTMENT_PRESET_CONFIG;
    case TASK_TEMPLATE_TYPES.todo:
    default:
      return PRESET_TASK_CONFIG;
  }
};
